"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use CartEmpty from foundation/CartEmpty
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Cart = createSVGIcon(
  <>
    <path stroke="currentColor" d="M.5 4.75H16.5V16.5H.5z" />
    <path d="M3.825 7.225V.85h9.35v6.375" stroke="currentColor" />
  </>,
  "Cart",
  { viewBox: "0 0 17 17", titleAccess: "Cart", fill: "none" }
);
